import * as React from 'react';

export default function SearchBar({ variant, searchStrings, setSearchStrings }) {
    const handleClear = () => {
        searchStrings[variant] = "";
        setSearchStrings({
            'Input': searchStrings['Input'],
            'Output': searchStrings['Output']
        });
    };

    const handleChange = (e) => {
        searchStrings[variant] = e.target.value;
        setSearchStrings({
            'Input': searchStrings['Input'],
            'Output': searchStrings['Output']
        });
    };

    return (
        <div className="mb-1 mt-1 ml-1">
            <div className="relative w-[90%] mr-1">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                    <span className="material-symbols-outlined text-[20px] text-slate-400">search</span>
                </div>
                <input
                    type="text"
                    placeholder="Search"
                    value={searchStrings[variant]}
                    onChange={handleChange}
                    className="w-full h-[32px] pl-10 pr-10 bg-white/45 border-0 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                />
                <button
                    onClick={handleClear}
                    className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-slate-100 rounded transition-colors"
                    style={{ visibility: searchStrings[variant].length ? 'visible' : 'hidden' }}
                >
                    <span className="material-symbols-outlined text-[18px] text-slate-600">close</span>
                </button>
            </div>
        </div>
    )
}
